import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ts-icon',
  template: ` <mat-icon
    class="ts-icon"
    [class.fa-margin]="fontSet === 'fa'"
    [svgIcon]="svgIcon"
    [fontIcon]="fontIcon"
    [fontSet]="fontSet"
    [inline]="true"
    [ngClass]="{
      'ts-icon-black': color === 'black',
      'ts-icon-red': color === 'red',
      'ts-icon-gray': color === 'gray',
      'ts-icon-light-gray': color === 'light-gray',
      'ts-icon-orange': color === 'orange',
      'ts-icon-white': color === 'white',
      'ts-icon-green': color === 'green',
      'material-icons-outlined': !!outlined,
      'fa-margin': fontSet === 'fa',
    }"
    [style]="getStyle()"
  ></mat-icon>`,
  host: { class: 'ts-icon' },
  styleUrls: ['./ts-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TSIconComponent {
  @Input() set icon(icon: string) {
    if (icon.includes('heroicons') || icon.includes('ts_') || icon.includes('.svg')) {
      this.svgIcon = icon;
      this.fontIcon = undefined;
    } else {
      this.fontIcon = icon;
      icon.startsWith('fa') ? (this.fontSet = 'fa') : undefined;
      this.svgIcon = undefined;
    }
  }

  @Input() color: 'red' | 'black' | 'gray' | 'light-gray' | 'orange' | 'white' | 'green';
  @Input() outlined: boolean;
  @Input() tooltip: string;
  @Input() size: 'x-small' | 'small' | 'mid-small' | 'medium' | 'large' = 'small';

  svgIcon: string | undefined = undefined;
  fontIcon: string | undefined = undefined;
  fontSet: string | undefined = undefined;

  getStyle(): any {
    switch (this.size) {
      case 'x-small':
        return { width: '14px !important', height: '14px !important', 'min-width': '14px !important' };
      case 'small':
        return { width: '16px !important', height: '16px !important' };
      case 'mid-small':
        return { width: '24px !important', height: '24px !important' };
      case 'medium':
        return { width: '40px !important', height: '40px !important' };
      case 'large':
        return { width: '64px !important', height: '64px !important' };
    }
  }
}
